module.exports = __webpack_public_path__ + "static/assets/4be4be5c1d421c70060c33b427276953.png";